<template>
  <div class="w preview1" :class="{ showX: w <= 1200 }">
    <div ref="container" class="container">
      <div id="container">
        <div class="scrollBar"></div>
        <div id="preview" :style="`opacity: ${loaded ? 1 : 0};`"></div>
        <div ref="charts" style="width: 100%; height: 100%;" v-show="isChartsShow">
          <div class="left">
            <div class="box" id="effectiveState" @mouseenter="stopAnimation" @mouseleave="runAnimation">
              <h1 class="title">{{ $t('station.effectiveState') }}</h1>
              <span class="left" @click="changeEffectiveState"></span>
              <span class="right" @click="changeEffectiveState"></span>
              <ul :style="{ left }" ref="effectiveState">
                <li>
                  <h3>{{ $t('station.accumulate') }}</h3>
                  <div class="wrapper">
                    <span>
                      <h4 class="innerTitle">{{ $t('station.electricity')}} kW·H</h4>
                      <span>{{ totalKwh }}</span>
                    </span>
                    <span>
                      <h4 class="innerTitle">{{ $t('station.flow')}} {{ unit }}</h4>
                      <span>{{ totalNm }}</span>
                    </span>
                  </div>
                  <div class="gasElectricRatio">
                    <div>{{ $t('station.ratio') }}{{ totalP }} kW·H/{{ unit }}</div>
                  </div>
                </li>
                <li>
                  <h3>{{ $t('station.current') }}</h3>
                  <div class="wrapper">
                    <span>
                      <h4 class="innerTitle">{{ $t('station.electricityL')}} kW</h4>
                      <span>{{ liveKw }}</span>
                    </span>
                    <span>
                      <h4 class="innerTitle">{{ $t('station.flowL')}} {{ unit }}/min</h4>
                      <span>{{ liveNm }}</span>
                    </span>
                  </div>
                  <div class="gasElectricRatio">
                    <div>{{ $t('station.ratio') }}{{ liveP }} kW·H/{{ unit }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="box" id="socialBenefit">
              <h1 class="title">{{ $t('station.socialBenefit') }}</h1>
              <span>
                <h4 class="innerTitle">{{ $t('station.es') }} kW·H</h4>
                <span>{{ totalReduce }}</span>
              </span>
              <span>
                <h4 class="innerTitle">{{ $t('station.cr') }} t</h4>
                <span>{{ CO2 }}</span>
              </span>
            </div>
            <div class="box charts">
              <h1 class="chartsTitle">{{ $t('station.ec7') }}</h1>
              <div class="container">
                <h1 class="title">{{ $t('station.ratioT') }}</h1>
                <h3 class="unit">kWh/{{ unit }}</h3>
                <div id="percent"></div>
              </div>
              <div class="container">
                <h1 class="title">{{ $t('station.gas') }}</h1>
                <h3 class="unit">{{ unit }}</h3>
                <div id="gasConsumption"></div>
              </div>
              <div class="container">
                <h1 class="title">{{ $t('station.electricity') }}</h1>
                <h3 class="unit">kWh</h3>
                <div id="electricityConsumption"></div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="box" id="runningState">
              <h1 class="title">{{ $t('station.state') }}</h1>
              <ul class="wrapper" style="margin-top: 20px">
                <li class="online">
                  <div class="text">
                    {{ (runningState["online"] || 0) + (runningState["running"] || 0)}}<span v-show="lang === 'zh'">台</span>
                  </div>
                  <div class="img"></div>
                  <div class="description">{{ $t('station.running') }}</div>
                </li>
                <li class="standy">
                  <div class="text">
                    {{ (runningState["sleep"] || 0) + (runningState["standby"] || 0)}}<span v-show="lang === 'zh'">台</span>
                  </div>
                  <div class="img"></div>
                  <div class="description">{{ $t('station.standby') }}</div>
                </li>
                <li class="offline">
                  <div class="text">
                    {{ (runningState["offline"] || 0) + (runningState["prepare"] || 0)}}<span v-show="lang === 'zh'">台</span>
                  </div>
                  <div class="img"></div>
                  <div class="description">{{ $t('station.offline') }}</div>
                </li>
              </ul>
              <ul class="wrapper">
                <li class="hitch">
                  <div class="text">
                    {{ runningState["error"] || 0}}<span v-show="lang === 'zh'">台</span>
                  </div>
                  <div class="img"></div>
                  <div class="description">{{ $t('station.error') }}</div>
                </li>
                <li class="maintain">
                  <div class="text">
                    {{ runningState["maintain"] || 0}}<span v-show="lang === 'zh'">台</span>
                  </div>
                  <div class="img"></div>
                  <div class="description">{{ $t('station.maintain') }}</div>
                </li>
              </ul>
            </div>
            <div class="box" id="live">
              <h1 class="title">{{ $t('station.pressure') }}</h1>
              <span v-if="pressure.length > 1" class="symbol_right">{{
                pressure[pressure.length - 1]
              }}</span>
              <span v-if="pressure.length === 1" class="symbol_center">{{
                pressure[0]
              }}</span>
              <span class="unit">MPa</span>
              <div id="pressure"></div>
            </div>
            <div class="box" id="warningRecord">
              <h1 class="title">{{ $t('station.warn') }}</h1>
              <div class="marquee">
                <ul
                  class="marquee-view"
                  ref="marquee"
                  @mouseenter="pauseAnimation"
                  @mouseleave="playAnimation"
                >
                  <li
                    v-for="(record, index) in warningRecord"
                    :key="index"
                    :class="record.warningLevel"
                    @mousedown="showModel(record, index)"
                  >
                    <div class="container">
                      <div
                        class="row scroll"
                        :class="{ animation: record.warningName.length + record.noticeContent.length > maxLength }"
                        @mouseleave="initialize(index)"
                      >
                        <div class="col" v-if="record.warningName.length + record.noticeContent.length > maxLength">
                          <span class="color">{{ record.warningName }}&nbsp;&nbsp;</span>
                          <span class="content color">
                            {{ record.noticeContent }}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </span>
                        </div>
                        <div class="col" v-if="record.warningName.length + record.noticeContent.length > maxLength">
                          <span class="color">{{ record.warningName }}&nbsp;&nbsp;</span>
                          <span class="content color">
                            {{ record.noticeContent }}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col color" style="padding-left: 8px">{{ level[record.warningLevel] }}</div>
                        <div class="col date">{{ record.createdAt }}</div>
                      </div>
                      <div class="flex" v-if="record.warningName.length + record.noticeContent.length <= maxLength">
                        <span class="color">{{ record.warningName }}&nbsp;&nbsp;</span>
                        <span class="content color">
                          {{ record.noticeContent }}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="visible" title="预警详情" ok-text="已读" @ok="noticeWarning" :confirm-loading="confirmLoading" @cancel="handleCancel">
      <p style="margin-bottom: 12px;">预警名称：{{ record.warningName }}</p>
      <p style="margin-bottom: 12px;">预警内容：{{ record.noticeContent }}</p>
      <p style="margin-bottom: 12px;">预警等级：{{ level[record.warningLevel] }}</p>
      <p style="margin-bottom: 12px;">创建日期：{{ record.createdAt }}</p>
    </a-modal>
  </div>
</template>

<script>
import deviceGroupApi from "@/api/device-group"
import Konva from 'konva'
import warningApi from "@/api/warning"
import { websocketUrl } from "@/plugins/service"
import { deviceApi } from "@/api/station"
import {
  AddDatetimeToAnim,
  startFlowingAnimation,
  destroyAnimation,
} from "@/views/EquipmentManager/EquipmentGroupDetail/konva-util"
// import warningRecord from "./testData"
import moment from 'moment'
import widget from '../../EquipmentGroupDetail/konva-widget'
import { getDeviceGroup, getDevicesStatus, getMonthReport, getDeviceAggregation, getMultiAggregation, searchDeviceList, getDeviceHistoryData, switchDevice } from '@/api/device'
import { getWarningRecordListByStation, noticeWarningRecord } from '@/api/warning'
import { getDict } from '@/api/dict'
import backBorder from '@/assets/backBorder.png'
import { nanoid } from 'nanoid'

export default {
  props: {
    changeComponent: Function
  },
  data() {
    return {
      left: "0%",
      warningRecord: [],
      pressure: [],
      runningState: {},
      totalReduce: 0,
      totalKwh: 0,
      totalNm: 0,
      totalP: 0,
      CO2: 0,
      liveKw: 0,
      liveNm: 0,
      liveP: 0,
      isChartsShow: false,
      maxLength: 30,
      dataShow: false,
      count: 0,
      visible: false,
      record: {},
      level: {
        URGENT: '紧急',
        IMPORTANT: '重要',
        MINOR: '次要',
        PROMPT: '提示'
      },
      confirmLoading: false,
      unitShow: false,
      statsInterval: null,
      itemStyle: {
        hex8: '#5470C6FF',
        rgba: {
          r: 84,
          g: 112,
          b: 198,
          a: 1
        }
      },
      linearEnd: {
        hex8: '#061E3C99',
        rgba: {
          r: 6,
          g: 30,
          b: 60,
          a: .6
        }
      },
      linearStart: {
        hex8: '#157FFF99',
        rgba: {
          r: 21,
          g: 127,
          b: 255,
          a: .6
        }
      },
      unit: 'Nm³',
      xColor: {
        hex8: '#6A6D77FF',
        rgba: {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }
      },
      yColor: {
        hex8: '#6A6D77FF',
        rgba: {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }
      },
      labelColor: {
        hex8: '#FFFFFFFF',
        rgba: {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }
      },
      loaded: false,
      w: 0,
      h: 0
    }
  },
  created () {
    if (this.$route.query.scale) {
      this.mobileScale = +this.$route.query.scale
    }
    this.charts = {}
    this.options = {}
    // localStorage.removeItem("connecting")
    this.connecting = false
    this.stationId = this.$route.query.id
    this.timerOfAggregation = {}
    this.effectiveWebsocket = {}
    this.timerOfEffectiveAccumulation = {}
    this.timerOfHbpSender = {}
    this.effectiveConnecting = {}
    this.effectiveFWebSocket = {}
    this.timerOfsocialEffects = {}
    this.timerOfRunningStates = {}
    this.isFullScreen = false
    this.singleDeviceW = {}
  },
  async mounted() {
    this.page = 1
    this.size = 100
    this.total = 0
    this.limitConnect = 0
    this.stationCode = this.$route.query.stationCode
    this.lineXAxis = []
    this.eReduce = 0
    this.gReduce = 0
    this.animation = []
    await this.getDeviceAndPressureInfo()
    this.getRunningState()
    this.getChartsState()
    this.setDate()
    let id = this.$route.query.id
    this.stationId = id
    const res = await getDict(this.lang === 'en' ? 'en-US' : 'zh-CN', 'deviceStatus')
    this.deviceStatus = res.data.content
    const interval = await this.loadStageData(id)
    const el = this.$refs.container
    const ratio = 1920 / 1080
    let w = window.innerWidth
    let h = Math.ceil(w / ratio)
    el.style.width = w + 'px'
    el.style.height = h + 'px'

    this.stage.width(w)
    this.stage.height(h)
    this.stage.find(n => {
      if (n.attrs.name === 'img') {
        const img = new Image()
        img.src = n.attrs.url
        img.onerror = () => {
          n.attrs.jump = true
        }
        img.onload = () => {
          n.attrs.image = img
        }
      }
    })
    const effectiveAccumulations = this.stage.find('.effectiveAccumulation')
    if (effectiveAccumulations.length) {
      effectiveAccumulations.forEach(effectiveAccumulation => {
        const id = effectiveAccumulation.getAttr('id')
        this.getEffectiveAccumulationData(effectiveAccumulation)
        const gap = effectiveAccumulation.getAttr('gap')
        const updateTermNumber = effectiveAccumulation.getAttr('updateTermNumber')
        if (gap && updateTermNumber) {
          const time = gap * updateTermNumber * 1000
          this.timerOfEffectiveAccumulation[id] = setInterval(() => this.getEffectiveAccumulationData(effectiveAccumulation), time)
        }
      })
    }
    const efs = this.stage.find('.effectiveCurrent')
    if (efs.length) {
      efs.forEach(ef => {
        const e = ef.getAttr('e') || []
        const f = ef.getAttr('f') || []
        const ds = e.concat(f)
        const id = ef.getAttr('id')
        if (ds.length) {
          this.connectEffectiveWebscoket(ef)
          this.timerOfHbpSender[id] = setInterval(() => {
            if (this.effectiveWebsocket[id] && !this.effectiveConnecting[id]) {
              try {
                this.effectiveWebsocket[id].send(this.stationCode)
              } catch(e) {
                console.log(e)
              } finally {
                this.effectiveFWebSocket[id] = false
                setTimeout(() => {
                  if (!this.effectiveFWebSocket[id]) {
                    if (this.effectiveWebsocket[id] && !this.effectiveConnecting[id]) {
                      this.effectiveWebsocket[id].close()
                      this.effectiveWebsocket[id] = null
                    }
                    if (!this.effectiveConnecting[id]) {
                      this.effectiveConnecting[id] = true
                      setTimeout(() => {
                        this.connectEffectiveWebscoket(ef)
                        this.effectiveConnecting[id] = false
                      }, 10000)
                    }
                  }
                }, 3000)
              }
            } else if (!this.effectiveFWebSocket[id] && !this.effectiveConnecting[id]) {
              if (!this.effectiveConnecting[id]) {
                this.effectiveConnecting[id] = true
                setTimeout(() => {
                  this.connectEffectiveWebscoket(ef)
                  this.effectiveConnecting[id] = false
                }, 10000)
              }
            }
          }, 10000)
        } else {
          ef.findOne('.ev').text('0')
          ef.findOne('.fv').text('0')
          ef.findOne('.ratioValue').text('0.00000')
        }
      })
    }
    const socialEffects = this.stage.find('.socialEffective')
    if (socialEffects.length) {
      socialEffects.forEach(socialEffect => {
        this.setSocialEffectiveState(socialEffect)
        const gap = socialEffect.getAttr('gap')
        const updateTermNumber = socialEffect.getAttr('updateTermNumber')
        const id = socialEffect.getAttr('id')
        if (gap && updateTermNumber) {
          this.timerOfsocialEffects[id] = setInterval(() => {
            console.log('timerOfsocialEffects')
            this.setSocialEffectiveState(socialEffect)
          }, gap * updateTermNumber * 1000);
        }
      })
    }
    this.w = w
    this.h = h
    this.id = id
    this.bindResizeChange()

    w = null
    h = null
    id = null
    const now = +new Date()
    // this.timerOfAggregation = setInterval(this.drawAggregation, 3600000)
    this.flexible()
    this.getWarningData()
    this.drawPressureChart()
    await this.getDataByMonth()
    const { xAxisData, chartsData } = this.setChartsGroupData()
    this.drawChartsGroup(xAxisData, chartsData)
    this.disabled = false
    this.connectServer()
    this.hbpSenderTimer = setInterval(() => {
      if (this.webSocket && !this.connecting) {
        try {
          this.webSocket.send(this.stationCode)
        } catch(e) {
          console.log(e)
        } finally {
          this.fWebSocket = false
          setTimeout(() => {
            if (!this.fWebSocket) {
              if (this.webSocket && !this.connecting) {
                this.webSocket.close()
                this.webSocket = null
              }
              this.reconnect()
            }
          }, 3000)
        }
      } else if (!this.webSocket && !this.connecting) {
        this.reconnect()
      }
    }, 10000)
    this.setStatsWidgetData(interval)
    this.manageTimers()
    setTimeout(async () => {
      this.resize()
      const promises = []
      this.stage.find('.StackedLine').forEach(s => {
        let img = new Image()
        const bg = s.findOne('.StackedLineBackground')
        img.src = backBorder
        img.onload = () => {
          bg.attrs.image = img
          this.layer.draw()
        }
        const image = s.findOne('.img')
        image.width(500)
        image.height(200)
  
        const id = s.getAttr('id')
        const deviceId = s.getAttr('deviceId')
        const point = s.getAttr('point')
        const pointName = s.getAttr('pointName')
        const maxPoints = s.getAttr('maxPoints') || 20
        if (deviceId && point) {
          const div = document.createElement('div')
          div.style.position = 'absolute'
          const client = s.getClientRect()
          div.style.width = client.width + 'px'
          div.style.height = client.height + 'px'
          div.style.left = client.x + 20 + 'px'
          div.style.top = client.y + 'px'
          div.id = id
          div.style.zIndex = 101
          container.appendChild(div)
          promises.push(new Promise(async (resolve, reject) => {
            try {
              const device = await searchDeviceList(1, 1, {
                query: [],
                filter: [
                  {
                    field: 'id',
                    value: deviceId
                  }
                ]
              })
              if (device.data.total) {
                const intervalTime = device.data.records[0]?.intervalTime || 180
                const startTime = now - (maxPoints + 10) * intervalTime * 1000
                const { data } = await getDeviceHistoryData({
                  deviceId,
                  pointCode: point,
                  startTime,
                  endTime: now
                })
                let xAxis = []
                let seriesData = data.map(d => {
                  xAxis.push(moment(+new Date(d.time)).format('HH:mm:ss'))
                  return d[point]
                })
                xAxis = xAxis.slice(-maxPoints)
                seriesData = seriesData.slice(-maxPoints)
                // this.drawStackedLine(id, pointName, s, xAxis, seriesData)
                resolve([
                  id,
                  pointName,
                  s,
                  xAxis,
                  seriesData
                ])
              }
            } catch(e) {
              console.log(e)
              reject()
            }
          }))
        }
      })
      this.stage.find('.stackedLine2').forEach(s => {
        s.y(s.y() - 30)
        const title = s.findOne(".stackedLine2Title")
        title.y(40)
        const image = s.findOne('.img')
        image.width(500)
        image.height(220)
        image.y(30)
        image.draggable(false)
        // img.src = bg.attrs.src
        // img.onload = () => {
        //   bg.attrs.image = img
        //   this.layer.draw()
        // }
  
        const id = s.getAttr('id')
        const deviceId = s.getAttr('deviceId')
        const point = s.getAttr('point')
        const pointName = s.getAttr('pointName')
        const maxPoints = s.getAttr('maxPoints') || 20
        if (deviceId && point) {
          const div = document.createElement('div')
          div.style.position = 'absolute'
          const client = s.getClientRect()
          div.style.width = client.width + 'px'
          div.style.height = client.height - 30 + 'px'
          div.style.left = client.x + 'px'
          div.style.top = client.y + 30 + 'px'
          div.id = id
          div.style.zIndex = 101
          container.appendChild(div)
          promises.push(new Promise(async (resolve, reject) => {
            try {
              const device = await searchDeviceList(1, 1, {
                query: [],
                filter: [
                  {
                    field: 'id',
                    value: deviceId
                  }
                ]
              })
              if (device.data.total) {
                const intervalTime = device.data.records[0]?.intervalTime || 180
                const startTime = now - (maxPoints + 10) * intervalTime * 1000
                const { data } = await getDeviceHistoryData({
                  deviceId,
                  pointCode: point,
                  startTime,
                  endTime: now
                })
                let xAxis = []
                let seriesData = data.map(d => {
                  xAxis.push(moment(+new Date(d.time)).format('HH:mm:ss'))
                  return d[point]
                })
                xAxis = xAxis.slice(-maxPoints)
                seriesData = seriesData.slice(-maxPoints)
                // this.drawStackedLine(id, pointName, s, xAxis, seriesData)
                resolve([
                  id,
                  pointName,
                  s,
                  xAxis,
                  seriesData,
                  true
                ])
              }
            } catch(e) {
              console.log(e)
              reject()
            }
          }))
        }
      })

      const parameters = await Promise.all(promises)
      parameters.forEach(p => this.drawStackedLine(...p))
      
      this.drawAggregation()
    }, 100)
    this.loaded = true
  },
  beforeDestroy() {
    this.webSocket?.close()
    this.pressureChart?.dispose()
    this.percent?.dispose()
    this.gasConsumption?.dispose()
    this.electricityConsumption?.dispose()
    destroyAnimation()
    this.clearTimers()
    document.removeEventListener("fullscreenchange", this.handleFullscreenchange)
    localStorage.removeItem("connecting")
    clearInterval(this.statsInterval)
    clearInterval(this.hbpSenderTimer)
    // clearInterval(this.timerOfAggregation)
    for (let key in this.timerOfAggregation) {
      clearInterval(this.timerOfAggregation[key])
    }
    for (let key in this.timerOfEffectiveAccumulation) {
      clearInterval(this.timerOfEffectiveAccumulation[key])
    }
    for (let key in this.timerOfHbpSender) {
      clearInterval(this.timerOfHbpSender[key])
    }
    for (let key in this.effectiveWebsocket) {
      this.effectiveWebsocket[key].close()
      this.effectiveWebsocket[key] = null
    }
    for (let key in this.timerOfsocialEffects) {
      clearInterval(this.timerOfsocialEffects[key])
    }
    for (let key in this.timerOfRunningStates) {
      clearInterval(this.timerOfRunningStates[key])
    }
  },
  destroyed() {
    this.webSocket = null
    this.pressureChart = null
    this.percent = null
    this.gasConsumption = null
    this.electricityConsumption = null
    localStorage.removeItem("connecting")
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.translate()
    }
  },
  methods: {
    flexible() {
      const docEl = document.documentElement
      const dpr = window.devicePixelRatio || 1
      this.setBodyFontSize(dpr)
      this.setRemUnit(docEl)
    },
    async getStackedBarData(
      id,
      deviceId,
      pointCode,
      aggregationType,
      term,
      termNumber,
      node,
      name
    ) {
      let startTime, endTime;
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      if (term === "30d") {
        const firstDayOfNextMonth = +new Date(year, month + 1);

        let targetMonth = month - termNumber + 1;
        const targetYear = year + Math.floor(targetMonth / 12);
        targetMonth = (targetMonth + 12) % 12;
        const firstDayOfTargetMonth = +new Date(targetYear, targetMonth, 1);
        startTime = firstDayOfTargetMonth;
        endTime = firstDayOfNextMonth;
      }
      if (term === "1w") {
        const now = new Date()
        const start = now - termNumber * 7 * 24 * 60 * 60 * 1000
        startTime = +this.getMonday(start)
        endTime = +this.getSunday(now)
      }
      if (term === "1d") {
        const date = now.getDate();
        endTime = +new Date(year, month, date + 1, 0, 0, 0, 0);
        startTime = +new Date(year, month, date - termNumber + 1, 0, 0, 0, 0);
      }
      if (term === '1h') {
        // 获取当前时间对应的整点时间戳
        const now = new Date()
        now.setMinutes(0, 0, 0); // 将分钟、秒钟和毫秒数设为 0
        now.setHours(now.getHours() + 1); // 将小时数加一，表示下一个整点
        endTime = now.getTime()
        startTime = endTime - termNumber * 60 * 60 * 1000
      }

      if (node.getAttr("ratio")) {
        try {
          const { data } = await getMultiAggregation(
            [
              {
                duration: term,
                deviceId: node.getAttr("LLJs") || [],
                pointCode: node.getAttr("LLJPoint"),
                aggregationType,
                startTime,
                endTime
              },
              {
                duration: term,
                deviceId: node.getAttr("DBs") || [],
                pointCode: node.getAttr("DBPoint"),
                aggregationType,
                startTime,
                endTime
              }
            ]
          )
          console.log(data)
          const xAxis = [];
          const seriesData = [];
          let value, n;
          let start = term === '1d' ? 0 : 1, end = data[0].values.length
          if (term === "1w") {
            start = end - termNumber
          }
          let week
          for (let i = start; i < end; i++) {
            value = data[0].values[i];
            if (term === "1d") {
              xAxis.push(value.time.substring(5, 10));
            }
            if (term === "1w") {
              week = this.getWeekNumber(value.time)
              let s = week.weekNumber
              if (this.lang === "en") {
                if (s == 1) {
                  s += "st"
                } else if (s == 2) {
                  s += "nd"
                } else if (s == 3) {
                  s += "rd"
                } else {
                  s += "th"
                }
              } else {
                s += "周"
              }
              xAxis.push(s)
            }
            if (term === "30d") {
              xAxis.push(+value.time.substring(5, 7) + "月");
            }
            if (term === '1h') {
              xAxis.push(value.time.split(' ')[1].substring(0, 5))
            }
            if (value.value && data[1].values[i]?.value) {
              n = +((data[1].values[i].value / value.value).toFixed(5))
            } else {
              n = 0
            }
            seriesData.push(n);
          }
          
          this.drawStackedBar(id, xAxis, seriesData, node)
          return
        } catch(e) {
          console.log(e)
          return
        }
      }

      try {
        const { data } = await getMultiAggregation([
          {
            duration: term,
            deviceId: deviceId,
            pointCode,
            aggregationType,
            startTime,
            endTime
          }
        ]);
        // this.stackedBarData = data
        const xAxis = [];
        const seriesData = [];
        let value;
        let start = term === '1d' ? 0 : 1, end = data[0].values.length
        if (term === "1w") {
          start = end - termNumber
        }
        let week
        for (let i = start; i < end; i++) {
          value = data[0].values[i];
          if (term === "1d") {
            xAxis.push(value.time.substring(5, 10));
          }
          if (term === "1w") {
            week = this.getWeekNumber(value.time)
            let s = week.weekNumber
            if (this.lang === "en") {
              if (s == 1) {
                s += "st"
              } else if (s == 2) {
                s += "nd"
              } else if (s == 3) {
                s += "rd"
              } else {
                s += "th"
              }
            } else {
              s += "周"
            }
            xAxis.push(s)
          }
          if (term === "30d") {
            xAxis.push(+value.time.substring(5, 7) + "月");
          }
          if (term === '1h') {
            xAxis.push(value.time.split(' ')[1].substring(0, 5))
          }
          seriesData.push(value.value);
        }

        this.drawStackedBar(id, xAxis, seriesData, node, name);
      } catch (e) {
        console.log(e);
      }
    },
    drawAggregation() {
      this.stage.find('.StackedBar').forEach(node => {
        console.log(node)
        let img = new Image()
        const bg = node.findOne('.StackedBarBackground')
        img.src = backBorder
        img.onload = () => {
          bg.attrs.image = img
          this.layer.draw()
        }
        const id = node.getAttr('id')
        console.log(id)
        let deviceId = node.getAttr('deviceId')
        if (deviceId) {
          if (!Array.isArray(deviceId)) {
            deviceId = [deviceId]
          }
        } else {
          deviceId = []
        }
        node.setAttr("deviceId", deviceId)
        const point = node.getAttr('point')
        if (node.attrs.ratio) {
          if (node.attrs.LLJs && node.attrs.DBs && node.attrs.LLJPoint && node.attrs.DBPoint) {
            let div = document.getElementById(id)
            if (!div) {
              div = document.createElement('div')
              div.style.position = 'absolute'
              // div.style.backgroundColor = 'skyblue'
              const client = node.getClientRect()
              const bgClient = bg.getClientRect()
              div.style.width = client.width + 'px'
              div.style.height = client.height  + 'px'
              div.style.left = client.x + 20 + 'px'
              div.style.top = client.y + 'px'
              div.id = id
              div.style.zIndex = 101
              container.appendChild(div)
            }
            const attrs = node.attrs;
            if (
              attrs.term &&
              attrs.termNumber &&
              attrs.aggregationType
            ) {
              console.log('drawBar');
              
              this.getStackedBarData(
                id,
                attrs.deviceId,
                attrs.point,
                attrs.aggregationType,
                attrs.term,
                attrs.termNumber,
                node
              );
            }
          }
        } else {
          const pointName = node.getAttr('pointName')
          if (deviceId && point) {
            let div = document.getElementById(id)
            if (!div) {
              div = document.createElement('div')
              div.style.position = 'absolute'
              // div.style.backgroundColor = 'skyblue'
              const client = node.getClientRect()
              const bgClient = bg.getClientRect()
              div.style.width = client.width + 'px'
              div.style.height = client.height  + 'px'
              div.style.left = client.x + 20 + 'px'
              div.style.top = client.y + 'px'
              div.id = id
              div.style.zIndex = 101
              container.appendChild(div)
            }
            const attrs = node.attrs;
            if (
              attrs.deviceId &&
              attrs.point &&
              attrs.term &&
              attrs.termNumber &&
              attrs.aggregationType
            ) {
              const updateTermNumber = node.getAttr('updateTermNumber') || 1
              const gap = node.getAttr('gap') || 3600
              this.timerOfAggregation[id] = setInterval(() => this.getStackedBarData(id, attrs.deviceId, attrs.point, attrs.aggregationType, attrs.term, attrs.termNumber, node, pointName), updateTermNumber * gap * 1000)
              this.$nextTick(() => this.getStackedBarData(id,
                attrs.deviceId,
                attrs.point,
                attrs.aggregationType,
                attrs.term,
                attrs.termNumber,
                node, pointName))
            }
          }
        }
      })
      this.stage.find('.StackedBar2').forEach(node => {
        const title = node.findOne(".stackedbar2Title")
        let y = 0, height = 0
        if (title) {
          y = title.y()
          height = title.height()
        }
        const image = node.findOne('.img')
        image.width(500)
        image.height(220)
        image.y(y + height + 10)
        image.draggable(false)
        let img = new Image()
        const bg = node.findOne('.StackedBar2Background')
        img.src = bg.attrs.url
        img.onload = () => {
          bg.attrs.image = img
          this.layer.draw()
        }
        const id = node.getAttr('id')
        console.log(id)
        let deviceId = node.getAttr('deviceId')
        if (deviceId) {
          if (!Array.isArray(deviceId)) {
            deviceId = [deviceId]
          }
        } else {
          deviceId = []
        }
        node.setAttr("deviceId", deviceId)
        const point = node.getAttr('point')
        if (node.attrs.ratio) {
          if (node.attrs.LLJs && node.attrs.DBs && node.attrs.LLJPoint && node.attrs.DBPoint) {
            let div = document.getElementById(id)
            if (!div) {
              div = document.createElement('div')
              div.style.position = 'absolute'
              // div.style.backgroundColor = 'skyblue'
              const client = node.getClientRect()
              const bgClient = bg.getClientRect()
              div.style.width = client.width + 'px'
              div.style.height = client.height - 30  + 'px'
              div.style.left = client.x + 20 + 'px'
              div.style.top = client.y + 30 + 'px'
              div.id = id
              div.style.zIndex = 101
              container.appendChild(div)
            }
            const attrs = node.attrs;
            if (
              attrs.term &&
              attrs.termNumber &&
              attrs.aggregationType
            ) {
              console.log('drawBar');
              
              this.getStackedBarData(
                id,
                attrs.deviceId,
                attrs.point,
                attrs.aggregationType,
                attrs.term,
                attrs.termNumber,
                node
              );
            }
          }
        } else {
          const pointName = node.getAttr('pointName')
          if (deviceId && point) {
            let div = document.getElementById(id)
            if (!div) {
              div = document.createElement('div')
              div.style.position = 'absolute'
              // div.style.backgroundColor = 'skyblue'
              const client = node.getClientRect()
              const bgClient = bg.getClientRect()
              div.style.width = client.width + 'px'
              div.style.height = client.height  + 'px'
              div.style.left = client.x + 20 + 'px'
              div.style.top = client.y + 'px'
              div.id = id
              div.style.zIndex = 101
              container.appendChild(div)
            }
            const attrs = node.attrs;
            if (
              attrs.deviceId &&
              attrs.point &&
              attrs.term &&
              attrs.termNumber &&
              attrs.aggregationType
            ) {
              const updateTermNumber = node.getAttr('updateTermNumber') || 1
              const gap = node.getAttr('gap') || 3600
              this.timerOfAggregation[id] = setInterval(() => this.getStackedBarData(id, attrs.deviceId, attrs.point, attrs.aggregationType, attrs.term, attrs.termNumber, node, pointName), updateTermNumber * gap * 1000)
              this.$nextTick(() => this.getStackedBarData(id,
                attrs.deviceId,
                attrs.point,
                attrs.aggregationType,
                attrs.term,
                attrs.termNumber,
                node, pointName))
            }
          }
        }
      })
    },
    drawStackedBar(id, xAxis, data, node = this.currentItem, name) {
      const yVisible = node.getAttr('yPosition')
      const xVisible = node.getAttr('xPosition')
      if (!this.charts[id]) {
        this.charts[id] = this.$echarts.init(
          document.querySelector(`#${id}`),
          null,
          {
            render: "canvas",
            useDirtyRect: false
          }
        );
      }
      const dataRate = node.getAttr("dataRate")
      if (dataRate && !isNaN(+dataRate) && dataRate !== "0") {
        for (let i = 0; i < data.length; i++) {
          data[i] = data[i] / dataRate
        }
      }

      const borderRadius = node.getAttr('borderRadius') || 0

      this.options[id] = {
        animation: false,
        backgroundColor: "",
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "10%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: xAxis,
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize: (node.getAttr('xFont') || 16) * (this.mobileScale || 1)
            },
            color: node.getAttr('xColor') || this.xColor.hex8,
            show: isNaN(+xVisible) ? true : !!+xVisible
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            onZero: false
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              fontSize: (node.getAttr('yFont') || 16) * (this.mobileScale || 1)
            },
            show: isNaN(+yVisible) ? true : !!+yVisible,
            color: node.getAttr('yColor') || this.yColor.hex8
          }
        },
        series: [
          {
            name,
            data,
            smooth: true,
            type: node.getAttr('chartType') || 'bar',
            itemStyle: {
              color: node.getAttr('itemStyle') || this.itemStyle.hex8,
              borderRadius: [+borderRadius, +borderRadius, 0, 0]
            },
            label: {
              show: true,
              color: node.getAttr('labelColor') || this.labelColor.hex8,
              position: 'top',
              fontSize: (node.getAttr('labelFont') || 16) * (this.mobileScale || 1)
            }
          }
        ]
      };
      let fixed = node.getAttr('fixed') + ''
      if (fixed && !isNaN(+fixed)) {
        this.options[id].series[0].label.formatter = o => (+o.value).toFixed(+fixed)
      }
      const colorLinear = node.getAttr('colorLinear')
      if (colorLinear === false) {
        delete this.options[id].series[0].areaStyle
      } else {
        this.options[id].series[0][(node.getAttr('chartType') || 'line') === 'line' ? 'areaStyle' : 'itemStyle'] = {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: node.getAttr('linearStart') || this.linearStart.hex8
            },
            {
              offset: 1,
              color: node.getAttr('linearEnd') || this.linearEnd.hex8
            }
          ]),
          borderRadius: [+borderRadius, +borderRadius, 0, 0]
        }
      }
      this.charts[id].setOption(
        this.options[id]
      );
      this.charts[id].resize()
    },
    drawStackedLine(id, name = "", node, xAxis = [], data_reference = [], changeGrid) {
      const yVisible = node.getAttr('yPosition')
      const xVisible = node.getAttr('xPosition')
      let data = data_reference.map(d => ({
        value: d,
        label: {
          show: false,
          position: 'top'
        }
      }))
      data.at(-1).label = {
        show: true,
        position: 'top'
      }

      const borderRadius = node.getAttr('borderRadius') || 0

      if (!this.charts[id]) {
        this.charts[id] = this.$echarts.init(
          document.querySelector(`#${id}`),
          null,
          {
            render: "canvas",
            useDirtyRect: false
          }
        );
      }

      this.options[id] = {
        animation: false,
        backgroundColor: "",
        tooltip: {
          trigger: "axis"
        },
        title: {
          text: "",
          textStyle: {
            color: "#fff"
          }
        },
        grid: {
          containLabel: true,
          top: "18%",
          left: "3%",
          bottom: "10%",
          right: "10%"
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: xAxis,
          axisLabel: {
            show: node.getAttr('xPosition') !== '0',
            textStyle: {
              fontSize: (node.getAttr('xFont') || 16) * (this.mobileScale || 1)
            },
            color: node.getAttr('xColor') || this.xColor.hex8,
            show: isNaN(+xVisible) ? true : !!+xVisible
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            onZero: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: node.getAttr('yPosition') !== '0',
            textStyle: {
              fontSize: (node.getAttr('yFont') || 16) * (this.mobileScale || 1)
            },
            show: isNaN(+yVisible) ? true : !!+yVisible,
            color: node.getAttr('yColor') || this.yColor.hex8
          },
          splitLine: {
            show: false
          },
          // min: -120,
          // max: -20
        },
        series: [
          {
            name,
            smooth: true,
            // showSymbol: false,
            type: node.getAttr('chartType') || 'line',
            data,
            label: {
              fontSize: (node.getAttr('labelFont') || 16) * (this.mobileScale || 1),
              color: node.getAttr('labelColor') || this.labelColor.hex8
            },
            // lineStyle: {
            //   color: 'red'
            // },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#157fff"
                },
                {
                  offset: 1,
                  color: "#061e3c"
                }
              ]),
              origin: 'start'
            },
            itemStyle: {
              color: node.getAttr('itemStyle') || this.itemStyle.hex8,
              borderRadius: [+borderRadius, +borderRadius, 0, 0]
            }
            // itemStyle: {
            //   normal: {
            //     label: {
            //       show: true,
            //       position: 'top',
            //       textStyle: {
            //         fontSize: 18,
            //         color: "#fff"
            //       },
            //       formatter: (params) => {
            //         if (params.dataIndex === this.options[deviceId + point].series[0].data.length - 1) {
            //           return params.value
            //         } else {
            //           return ""
            //         }
            //       }
            //     }
            //   }
            // }
          }
        ]
      };
      if (changeGrid) {
        this.options[id].grid = {
          containLabel: true,
          top: "20%",
          left: "3%",
          bottom: "10%",
          right: "3%"
        }
      }
      let fixed = node.getAttr('fixed') + ''
      if (fixed && !isNaN(+fixed)) {
        this.options[id].series[0].label.formatter = o => (+o.value).toFixed(+fixed)
      }
      const colorLinear = node.getAttr('colorLinear')
      if (colorLinear === false) {
        delete this.options[id].series[0].areaStyle
      } else {
        this.options[id].series[0][(node.getAttr('chartType') || 'line') === 'line' ? 'areaStyle' : 'itemStyle'] = {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: node.getAttr('linearStart') || this.linearStart.hex8
            },
            {
              offset: 1,
              color: node.getAttr('linearEnd') || this.linearEnd.hex8
            }
          ]),
          borderRadius: [+borderRadius, +borderRadius, 0, 0],
          origin: 'start'
        }
      }

      this.charts[id].setOption(this.options[id]);
    },
    setBodyFontSize(dpr) {
      if(document.body) {
        document.body.style.fontSize = (12 * dpr) + "px"
      } else {
        document.addEventListener("DOMContentLoaded", this.setBodyFontSize(dpr))
      }
    },
    setRemUnit(docEl, isFullScreen) {
      let rem
      if(isFullScreen) {
        rem = window.innerWidth / 20
        if(window.innerWidth <= 1680) {
          this.maxLength = 30
        }
      }
      else {
        if(window.innerWidth <= 1024) {
          this.maxLength = 16
          this.chartFontSize = 11
        } else if(window.innerWidth <= 1440) {
          this.maxLength = 18
          this.chartFontSize = 14
        } else if(window.innerWidth <= 1680) {
          this.maxLength = 15
          this.chartFontSize = 15
        }
        rem = window.innerWidth / 20
      }
      docEl.style.fontSize = rem + "px"
    },
    loadStageData(id) {
      return getDeviceGroup(id)
        .then(({ data }) => {
          const container = document.getElementById("preview")
          const i = JSON.parse(data.content)
          const model = data.extraProperty
          this.unitShow = model.stations?.length > 0
          let content
          if (i) {
            if (i.hasOwnProperty('single')) {
              content = i.single
            } else {
              content = data.content
            }
          }
          // let content = i.hasOwnProperty('single') ? i.single : data.content
          if(content) {
            this.stage = Konva.Node.create(content, "preview")
            this.stage.x(0)
            this.stage.y(0)
            this.stage.offsetX(0)
            this.stage.offsetY(0)
            this.stage.scale({
              x: 1,
              y: 1
            })

            container.style.backgroundColor = this.stage.attrs.backgroundColor

            this.stage.draggable(false)
            this.setDraggable(this.stage, false)

            this.stage.find(node => {
              if(node.attrs.name === "img") {
                const img = new Image()
                img.src = node.attrs.url
                !node.attrs.jump && (node.attrs.image = img)
                //
              }
            })

            this.stage.find(".datetime").forEach(node => {
              AddDatetimeToAnim(node)
            })

            this.stage.find(".flowingPipe").forEach(group => {
              const anim = startFlowingAnimation(group)
              this.animation.push(anim)
            })
            const nodes = this.stage.find('.effectiveAccumulation')
            if (nodes.length) {
              nodes.forEach(node => {
                const img = node.findOne('.effectiveAccumulationBackground')
                img.width(410)
                img.height(200)
                const image = new Image()
                image.src = img.attrs.url
                image.onload = () => {
                  img.attrs.image = image
                }
                const ratio = node.findOne('.ratio')
                ratio.cache({
                  padding: 10
                })
                ratio.filters([Konva.Filters.Blur])
                ratio.blurRadius(5)
              })
            }
            const efs = this.stage.find('.effectiveCurrent')
            if (efs.length) {
              efs.forEach(ef => {
                const img = ef.findOne('.effectiveCurrentBackground')
                img.width(410)
                img.height(200)
                const image = new Image()
                image.src = img.attrs.url
                image.onload = () => {
                  img.attrs.image = image
                }
                const ratio = ef.findOne('.ratio')
                ratio.cache({
                  padding: 10
                })
                ratio.filters([Konva.Filters.Blur])
                ratio.blurRadius(5)
              })
            }
            const warnings = this.stage.find('.warning')
            if (warnings.length) {
              warnings.forEach(ef => {
                const img = ef.findOne('.warningBackground')
                img.width(430)
                img.height(200)
                const image = new Image()
                image.src = img.attrs.url
                image.onload = () => {
                  img.attrs.image = image
                }
              })
            }
            const socialEffects = this.stage.find('.socialEffective')
            if (socialEffects.length) {
              socialEffects.forEach(socialEffect => {
                const img = socialEffect.findOne('.socialEffectiveBackground')
                img.width(410)
                img.height(120)
                const image = new Image()
                image.src = img.attrs.url
                image.onload = () => {
                  img.attrs.image = image
                }
              })
            }

            const runningStates = this.stage.find('.runningState')
            if (runningStates.length) {
              runningStates.forEach(r => {
                const img = r.findOne('.runningStateBackground')
                img.width(410)
                img.height(260)
                const image = new Image()
                image.src = img.attrs.url
                image.onload = () => {
                  img.attrs.image = image
                }
                const runningImg = r.findOne('.runningImg')
                const runningI = new Image()
                runningI.src = runningImg.attrs.url
                runningI.onload = () => {
                  runningImg.attrs.image = runningI
                }
                const sleepingImg = r.findOne('.sleepingImg')
                const sleepingI = new Image()
                sleepingI.src = sleepingImg.attrs.url
                sleepingI.onload = () => {
                  sleepingImg.attrs.image = sleepingI
                }
                const offlineImg = r.findOne('.offlineImg')
                const offlineI = new Image()
                offlineI.src = offlineImg.attrs.url
                offlineI.onload = () => {
                  offlineImg.attrs.image = offlineI
                }
                const errorImg = r.findOne('.errorImg')
                const errorI = new Image()
                errorI.src = errorImg.attrs.url
                errorI.onload = () => {
                  errorImg.attrs.image = errorI
                }
                const maintainImg = r.findOne('.maintainImg')
                const maintainI = new Image()
                maintainI.src = maintainImg.attrs.url
                maintainI.onload = () => {
                  maintainImg.attrs.image = maintainI
                }
                this.setConfigurationDeviceStatus(r)
                const gap = r.getAttr('gap')
                const updateTermNumber = r.getAttr('updateTermNumber')
                if (gap && updateTermNumber) {
                  this.timerOfRunningStates[nanoid()] = setInterval(() => this.setConfigurationDeviceStatus(r), gap * updateTermNumber * 1000)
                }
              })
            }
            // this.stage.find('.effectiveAccumulation')
            this.translate()
          } else {
            this.initial()
          }
          return data.interval
        })
    },
    connectEffectiveWebscoket(ef) {
      const id = ef.getAttr('id')
      const e = ef.getAttr('e') || []
      const f = ef.getAttr('f') || []
      const deviceCodes = e.concat(f) + ''
      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.effectiveWebsocket[id] = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/group/${this.$route.query.id}?token=${authorization}`)
      this.effectiveWebsocket[id].onopen = () => {
        this.effectiveWebsocket[id].send(deviceCodes)
      }
      this.effectiveWebsocket[id].onmessage = m => {
        if (m.data === this.stationCode) {
          this.effectiveFWebSocket[id] = true
          return
        }
        const record = JSON.parse(m.data)
        if (!record.device_code) {
          const node = this.stage.find('.effectiveCurrent').find(n=> {
            const e = n.getAttr('e') || []
            const f = n.getAttr('f') || []
            const ds = e.concat(f) + ''
            return ds && ds === deviceCodes
          })
          if (node) {
            node.findOne('.ev')?.text(record.power)
            node.findOne('.fv')?.text(record.flow)
            node.findOne('.ratioValue')?.text(record.gasElectricRatio)
          }
        }
      }
    },
    async translate() {
      const res = await getDict(this.lang === 'en' ? 'en-US' : 'zh-CN', 'deviceStatus')
      const deviceStatus = res.data.content

      const monitors = this.stage.find('.monitorBlock')
      monitors.forEach(m => {
        m.find('.statusTag').forEach(d => {
          const status = this.deviceStatus.find(s => s.text === d.text())
          if (status) {
            const s = deviceStatus.find(s => s.value === status.value)
            widget.dataBlock.updateHeaderTag(m, [s])
          }
        })
      })
      const list = this.stage.find('.dataBlock')
      list.forEach(m => {
        m.find('.statusTag').forEach(d => {
          const status = this.deviceStatus.find(s => s.text === d.text())
          if (status) {
            const s = deviceStatus.find(s => s.value === status.value)
            widget.dataBlock.updateHeaderTag(m, [s])
          }
        })
      })
      this.deviceStatus = deviceStatus
      const blockList = this.stage.find(".monitorRow")
      blockList.forEach(item => {
        const device = item.getParent().getAttr("device")
        const point = item.getAttr("dataPoint")
        if(!device || !point) {
          return
        }
        (point.details || []).forEach(d => {
          if (d.locale === 'zh-CH') {
            point.zh = d.name
          }
          if (d.locale === 'en-US') {
            point.en = d.name
          }
        })
        if (!point.zh) {
          point.zh = point.name
        }
        if (!point.en) {
          point.en = point.zh
        }
        const key = item.findOne('.monitorKey')
        if (key) {
          let name = key.getAttr('selfDefinedName')
          if (name) {
            point.zh = point.en = name
          }
          // const width = key.width()
          key.text(point[this.lang])
          // const value = item.findOne('.monitorValue')
          // if (value) {
          //   value.x(value.x() + key.width() - width)
          // }
          // const unit = item.findOne('.monitorUnit')
          // if (unit) {
          //   unit.x(unit.x() + key.width() - width)
          // }
        }
      })
      const dataList = this.stage.find(".dataRow")
      dataList.forEach(item => {
        const device = item.getAttr("device")
        const point = item.getAttr("dataPoint")
        if(!device || !point) {
          return
        }
        (point.details || []).forEach(d => {
          if (d.locale === 'zh-CH') {
            point.zh = d.name
          }
          if (d.locale === 'en-US') {
            point.en = d.name
          }
        })
        if (!point.zh) {
          point.zh = point.name
        }
        if (!point.en) {
          point.en = point.zh
        }
        const key = item.findOne('.dataKey')
        if (key) {
          let name = key.getAttr('selfDefinedName')
          if (name) {
            point.zh = point.en = name
          }
          // const width = key.width()
          key.text(point[this.lang])
          // const value = item.findOne('.dataValue')
          // if (value) {
          //   value.x(value.x() + key.width() - width)
          // }
          // const unit = item.findOne('.dataUnit')
          // if (unit) {
          //   unit.x(unit.x() + key.width() - width)
          // }
        }
      })
      if (this.monthList?.length) {
        const { xAxisData, chartsData } = this.setChartsGroupData()
        this.percent.setOption({
          xAxis: [
            {
              data: xAxisData
            }
          ],
          series: {
            data: chartsData[0]
          }
        })
        this.gasConsumption.setOption({
          xAxis: [
            {
              data: xAxisData
            }
          ],
          series: {
            data: chartsData[1]
          }
        })
        this.electricityConsumption.setOption({
          xAxis: [
            {
              data: xAxisData
            }
          ],
          series: {
            data: chartsData[2]
          }
        })
      }
      this.pressureChart?.setOption({
        series: [
          {
            name: this.$t('station.pressureC')
          }
        ]
      })
    },
    initial () {
      this.initStage()
      this.layer = new Konva.Layer()
      this.stage.add(this.layer)
      this.stage.x(0)
      this.stage.y(0)
      this.stage.offsetX(0)
      this.stage.offsetY(0)
      this.stage.scale({
        x: 1,
        y: 1
      })

      container.style.backgroundColor = this.stage.attrs.backgroundColor

      this.stage.draggable(false)
    },
    initStage () {
      this.stage = new Konva.Stage({
        backgroundColor: '#000334',
        width: window.innerWidth,
        height: window.innerHeight,
        container: 'preview',
        draggable: false
      })
    },
    resize() {
      const { stage } = this
      const layer = stage.getChildren()[0]
      this.layer = layer
      let group = this.getBasicGroup(layer)
      const scaleX = stage.width() / group.width
      const scaleY = stage.height() / group.height
      const scale = scaleX < scaleY ? scaleX : scaleY
      layer.scale({
        x: scale,
        y: scaleY
      })

      group = this.getBasicGroup(layer)

      layer.offsetX(-(stage.width() - group.width) / 2)
      layer.offsetY(-(stage.height() - group.height) / 2)

      if (this.isChartsShow) {
        this.percent?.resize()
        this.gasConsumption?.resize()
        this.electricityConsumption?.resize()
        this.pressureChart?.resize()
      }
      this.controlWidgets = []
      this.stage.find('.controlWidget').forEach(controlWidget => {
        controlWidget.hide()
        const text = controlWidget.findOne("Text").text()
        const div = document.createElement("div")
        div.classList.add("controlWidget")
        div.style.position = "absolute"
        const client = controlWidget.getClientRect()
        div.style.width = client.width + "px"
        div.style.height = client.height + "px"
        const el = this.$refs.container
        console.log(client, group, this.layer.scale(), el.clientWidth, el.clientHeight)
        div.style.left = ((client.x - group.x * this.layer.scaleX() + 50) / el.clientWidth * 100) + '%'
        div.style.top = ((client.y + group.y * this.layer.scaleY() + 20) / el.clientHeight * 100) + '%'
        div.innerHTML = `
          <button type="button" class="ant-btn ant-btn-primary" data-v-a1ccd506="">
            <span class="${text}">${text}</span>
          </button>
        `
        const container = document.getElementById("preview")
        div.style.zIndex = 101
        container.appendChild(div)
        this.controlWidgets.push(div)
        const dtuCode = controlWidget.getAttr("dtuCode")
        const deviceCode = controlWidget.getAttr("deviceCode")
        const pointCode = controlWidget.getAttr("pointCode")
        const value = controlWidget.getAttr("value")
        const deviceId = controlWidget.getAttr("deviceId")
        let delay = controlWidget.getAttr("delay") || 60
        if (dtuCode && deviceCode && deviceId && pointCode) {
          div.addEventListener("click", async () => {
            delay = controlWidget.getAttr("delay") || 60
            div.innerHTML = `
              <button type="button" class="ant-btn ant-btn-primary ant-btn-loading" data-v-a1ccd506="">
                <i aria-label="图标: loading" class="anticon anticon-loading">
                  <svg viewBox="0 0 1024 1024" data-icon="loading" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="anticon-spin">
                    <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                  </svg>
                </i>
                <span class="${text}">${text}</span>
              </button>
            `
            const { message } = await switchDevice({
              dtuCode,
              deviceCode,
              pointCode,
              value
            })
            this.$message.success(message)
            this.controlWidgets.forEach(c => {
              const text = c.querySelector("span").classList[0]
              c.innerHTML = `
                <button disabled type="button" class="ant-btn ant-btn-primary" data-v-a1ccd506="">
                  <span class="${text}">${delay}s后可${text}</span>
                </button>
              `
            })
            this.timerOfControlWidget = setInterval(() => {
              delay--
              this.controlWidgets.forEach(c => {
                const text = c.querySelector("span").classList[0]
                if (delay === 0) {
                  c.innerHTML = `
                    <button type="button" class="ant-btn ant-btn-primary" data-v-a1ccd506="">
                      <span class="${text}">${text}</span>
                    </button>
                  `
                  clearInterval(this.timerOfControlWidget)
                  this.timerOfControlWidget = null
                } else {
                  c.innerHTML = `
                    <button disabled type="button" class="ant-btn ant-btn-primary" data-v-a1ccd506="">
                      <span class="${text}">${delay}s后可${text}</span>
                    </button>
                  `
                }
              })
            }, 1000)
            const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
            if (this.singleDeviceW[deviceId] && ![WebSocket.CLOSED, WebSocket.CLOSING].includes(this.singleDeviceW[deviceId].readyState)) {
              this.singleDeviceW[deviceId].send("stop")
              this.singleDeviceW[deviceId].close()
              delete this.singleDeviceW[deviceId]
            }
            this.singleDeviceW[deviceId] = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/${deviceId}?token=${authorization}`)
            this.singleDeviceW[deviceId].onmessage = m => {
              if (m.data === "monitorTime") {
                this.singleDeviceW[deviceId].send("stop")
                this.singleDeviceW[deviceId].close()
                delete this.singleDeviceW[deviceId]
              }
            }
          })
        }
      })
    },
    getBasicGroup(layer) {
      const stage = layer.getStage()
      const nodes = layer.getChildren().filter(node => node.name() !== "transformer")

      let minX, minY, maxX, maxY
      minX = minY = Infinity
      maxX = maxY = -Infinity
      nodes.forEach(node => {
        const rect = node.getClientRect({
          relativeTo: stage
        })
        minX = rect.x < minX ? rect.x : minX
        minY = rect.y < minY ? rect.y : minY
        maxX = (rect.x + rect.width > maxX) ? (rect.x + rect.width) : maxX
        maxY = (rect.y + rect.height > maxY) ? (rect.y + rect.height) : maxY
      })

      const group = {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      }

      layer.move({
        x: -group.x,
        y: -group.y
      })

      return group
    },
    setFullscreen() {
      this.$refs.container.requestFullscreen()
    },
    async getChartsState() {
      try {
        const { data } = await getDeviceGroup(this.$route.query.id)
        this.chartsState = data.extraProperty
        this.isChartsShow = this.chartsState.charts.includes("1")
        this.dataShow = this.chartsState.model.includes("2")
      } catch(e) {
        console.log(e);
      }
    },
    bindResizeChange() {
      document.addEventListener("keydown", this.handleKeyDown)
    },
    setDraggable(node, draggable) {
      if(typeof node.getChildren === "function") {
        const children = node.getChildren()
        if(children.length !== 0) {
          children.forEach(node => {
            node.draggable(draggable)
            this.setDraggable(node, draggable)
          })
        }
      }
    },
    handleKeyDown (e) {
      if (e && e.keyCode === 122) {
        e.preventDefault() // 阻止默认事件
        // alert(this.isFullScreen)
        // this.isFullScreen = !this.isFullScreen
        // alert(this.isFullScreen)
        this.setFullscreen()
      }
    },
    handleFullscreenchange() {
      const el = this.$refs.container
      if(this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      const isFullScreen = document.fullscreenElement !== null
      // alert(this.isFullScreen)
      alert(isFullScreen)
      if(isFullScreen) {
        this.isChartsShow = this.chartsState.charts.includes("2")
        alert(window.innerWidth)
        el.style.width = window.innerWidth + "px"
        el.style.height = window.innerWidth * 1080 / 1920 + "px"
        this.setRemUnit(document.documentElement, true)
      } else {
        this.isChartsShow = this.chartsState.charts.includes("1")
        el.style.width = this.w + "px"
        el.style.height = this.h + "px"
        this.setRemUnit(document.documentElement)
      }
      this.resizeTimer = setTimeout(() => {
        this.loadStageData(this.id).then(() => {
          this.stage.width(+el.style.width.slice(0, -2))
          if(isFullScreen) {
            if(el.style.height.slice(0, -2) > window.innerHeight) {
              this.stage.height(+el.style.height.slice(0, -2))
              el.style.height = window.innerHeight + "px"
              el.style.overflowY = "auto"
              el.style.overflowX = "hidden"
            } else {
              el.style.height = window.innerWidth * 1080 / 1920 + "px"
              this.stage.height(+el.style.height.slice(0, -2))
              el.style.overflowY = "unset"
              el.style.overflowX = "unset"
            }
          } else {
            this.stage.height(+el.style.height.slice(0, -2))
            el.style.overflowY = "unset"
            el.style.overflowX = "unset"
          }
          // this.stage.find(node => {
          //   if(node.attrs.name === "img") {
          //     const img = new Image()
          //     img.src = node.attrs.url
          //     img.onerror = e => {
          //       console.log(e);
          //     }
          //     img.onload = () => {
          //       node.attrs.image = img
          //     }
          //     //
          //   }
          // })
          this.resize()
          this.stage.find('.StackedLine').forEach(node => {
            let img = new Image()
            const bg = node.findOne('.StackedLineBackground')
            img.src = backBorder
            img.onload = () => {
              bg.attrs.image = img
              this.layer.draw()
            }
            const id = node.getAttr('id')
            const deviceId = node.getAttr('deviceId')
            const point = node.getAttr('point')
            if (deviceId && point) {
              const div = document.querySelector(`#${id}`)
              if (div) {
                const client = node.getClientRect()
                div.style.width = client.width + 'px'
                div.style.height = client.height  + 'px'
                div.style.left = client.x + 20 + 'px'
                div.style.top = client.y + 'px'
                div.style.zIndex = 101
              }
              this.$nextTick(() => this.charts[id].resize())
            }
          })
          this.stage.find('.stackedLine2').forEach(node => {
            node.y(node.y() - 30)
            const title = node.findOne(".stackedLine2Title")
            title.y(40)
            const image = node.findOne('.img')
            image.width(500)
            image.height(220)
            image.y(30)
            image.draggable(false)
            const id = node.getAttr('id')
            const deviceId = node.getAttr('deviceId')
            const point = node.getAttr('point')
            if (deviceId && point) {
              const div = document.querySelector(`#${id}`)
              if (div) {
                const client = node.getClientRect()
                div.style.width = client.width + 'px'
                div.style.height = client.height - 30  + 'px'
                div.style.left = client.x + 20 + 'px'
                div.style.top = client.y + 30 + 'px'
                div.style.zIndex = 101
              }
              this.$nextTick(() => this.charts[id].resize())
            }
          })
          this.stage.find('.StackedBar').forEach(node => {
            let img = new Image()
            const bg = node.findOne('.StackedBarBackground')
            img.src = backBorder
            img.onload = () => {
              bg.attrs.image = img
              this.layer.draw()
            }
            const id = node.getAttr('id')
            const deviceId = node.getAttr('deviceId')
            const point = node.getAttr('point')
            if (deviceId && point) {
              const div = document.querySelector(`#${id}`)
              if (div) {
                const client = node.getClientRect()
                div.style.width = client.width + 'px'
                div.style.height = client.height  + 'px'
                div.style.left = client.x + 20 + 'px'
                div.style.top = client.y + 'px'
                div.style.zIndex = 101
              }
              this.$nextTick(() => this.charts[id].resize())
            }
          })
        })
      }, 100)
    },
    changeEffectiveState() {
      this.left = this.left === "0%" ? "-100%" : "0%"
      this.$refs.effectiveState.style.transition = "left 1s"
    },
    async getWarningData() {
      const { startTime, endTime, stationId } = this
      try {
        const { data } = await getWarningRecordListByStation({
          startTime,
          endTime,
          stationId
        })
        if (data) {
          this.warningRecord = data.filter(i => {
            if (!i.notices[0].isRead) {
              i.createdAt = moment(i.createdAt).format('YYYY-MM-DD HH:mm:ss ddd')
              return true
            }
            return false
          })
        }
        if (this.warningRecord.length > 4) {
          this.warningRecord = this.warningRecord.concat(this.warningRecord)
          this.$refs.marquee.style.animationDuration = `${
            this.warningRecord.length / 2 - 1
          }s`
        } else if (this.warningRecord.length > 0) {
          this.$refs.marquee.style.animationPlayState = "unset"
        }
      } catch(err) {
        console.error(err)
        this.$refs.marquee.style.animationPlayState = "unset"
      }
      this.$nextTick(() => {
        this.animations = document.querySelectorAll(".marquee .scroll")
      })
    },
    pauseAnimation() {
      this.$refs.marquee.style.animationPlayState = "paused"
    },
    playAnimation() {
      if (this.visible) {
        return
      }
      this.$refs.marquee.style.animationPlayState = "running"
    },
    initialize(i) {
      this.animations[i].classList.remove("animation")
      setTimeout(() => {
        this.animations[i].classList.add("animation")
      }, 100);
    },
    showModel(record, index) {
      this.record = record
      this.initialize(index)
      this.pauseAnimation()
      this.visible = true
    },
    async getDeviceAndPressureInfo() {
      try {
        const { data } = await getDeviceGroup(this.$route.query.id)
        if(data.extraProperty.pressure) {
          const temp = data.extraProperty.pressure.slice(2).split(".")
          this.deviceCode = temp[0]
          this.setData = temp[1].slice(0, -1)
        }
        this.unit = data.extraProperty.unit || 'Nm³'
        this.deviceCodes = []
        if (data.extraProperty.deviceCodes) {
          this.deviceCodes = JSON.parse(data.extraProperty.deviceCodes)
        }
        for (let i = 0; i < this.deviceCodes.length; i++) {
          const o = data.devices.find(device => device.code === this.deviceCodes[i])
          if(o?.type === "DB") {
            this.eReduce += o.initialValue || 0
          }
          if(o?.type === "LLJ") {
            this.gReduce += o.initialValue || 0
          }
        }
        this.gasElectricRatio = data.gasElectricRatio || 0
      } catch(e) {
        console.log(e);
      }
    },
    setDate() {
      let nowDate = +new Date()
      this.endDate = moment(nowDate).format("YYYY-MM-DD")
      this.startDate = moment(nowDate - 29 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD")
      this.endTime = nowDate
      this.startTime = nowDate - 24 * 3600 * 1000
    },
    async getDataByMonth() {
      if(this.deviceCodes?.length > 0) {
        let { startDate, endDate, deviceCodes } = this
        try {
          const { data } = await getMonthReport(startDate, endDate, deviceCodes + "")
          this.monthList = data.slice(-8)
          let target, totalNm = 0, totalKwh = 0, totalP
          for (let i = data.length - 2; i > -1; i--) {
            target = data[i]
            if (target.electricityMeterAccumulation > 0) {
              totalKwh = target.electricityMeterAccumulation - this.eReduce
              totalKwh = totalKwh > 0 ? totalKwh : 0
              if (target.flowMeterAccumulation > 0) {
                totalNm = target.flowMeterAccumulation - this.gReduce
                totalNm = totalNm > 0 ? totalNm : 0
              }
              break
            }
          }
          totalP = totalNm == 0 ? 0 : (totalKwh / totalNm)
          this.totalP = totalP.toFixed(5)
          this.totalKwh = totalKwh.toFixed(0)
          this.totalNm = totalNm.toFixed(0)
          // this.totalKwh = data[data.length - 2].electricityMeterAccumulation>0?(data[data.length - 2].electricityMeterAccumulation - this.eReduce).toFixed(0)>0?(data[data.length - 2].electricityMeterAccumulation - this.eReduce).toFixed(0):0:0
          // this.totalNm = data[data.length - 2].flowMeterAccumulation>0?(data[data.length - 2].flowMeterAccumulation - this.gReduce).toFixed(0)>0?(data[data.length - 2].flowMeterAccumulation - this.gReduce).toFixed(0):0:0
          // this.totalP = this.totalNm == 0 ? 0 : (this.totalKwh / this.totalNm).toFixed(5)

          if (this.gasElectricRatio) {
            this.totalReduce = (this.gasElectricRatio * this.totalNm - this.totalKwh).toFixed(0)
            this.CO2 = ((this.totalReduce * 0.942) / 1000).toFixed(3)
          } else {
            this.totalReduce = '0'
            this.CO2 = '0.000'
          }
        } catch(e) {
          console.log(e);
        }
      } else {
        this.monthList = []
      }
    },
    setChartsGroupData() {
      const data = this.monthList.slice(0, -1)
      const xAxisData = []
      const chartsData = [[], [], []]

      const units = ['', 'st', 'nd', 'rd', '']
      let unit = '日'
      for(let i = 0; i < data.length; i++) {
        const t = data[i].datetime.slice(-2)
        if (this.lang === 'en') {
          if (t < 4) {
            unit = units[+t]
          } else {
            unit = 'th'
          }
        }
        xAxisData.push(t + unit)
        const percent = data[i].flow === 0 ? 0 : (data[i].electricity / data[i].flow).toFixed(4)
        if(i < data.length - 1) {
          chartsData[0].push(percent)
          chartsData[1].push(data[i].flow)
          chartsData[2].push(data[i].electricity)
        } else {
          const label = {
            show: true,
            color: "#fff",
            fontSize: (this.chartFontSize || 18) * (this.mobileScale || 1),
            position: "top"
          }
          chartsData[0].push({
            value: percent,
            label
          })
          chartsData[1].push({
            value: data[i].flow,
            label
          })
          chartsData[2].push({
            value: data[i].electricity,
            label
          })
        }
      }

      return { xAxisData, chartsData }
    },
    drawPressureChart() {
      this.pressureChart = this.$echarts.init(
        document.getElementById("pressure"),
        null,
        {
          renderer: "canvas",
          useDirtyRect: false
        }
      )
      const option = {
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "30%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.lineXAxis,
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: this.$t('station.pressureC'),
            type: "line",
            stack: "Total",
            data: this.pressure,
            areaStyle: {
              opacity: .6,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#157fff"
                },
                {
                  offset: 1,
                  color: "#061e3c"
                }
              ])
            }
          }
        ]
      }
      this.pressureChart.setOption(option)
    },
    manageTimers() {
      this.clearTimers()
      this.oneMinute = setInterval(async () => {
        this.setDate()
        await this.getDataByMonth()
        const { xAxisData, chartsData } = this.setChartsGroupData()
        this.percent.setOption({
          xAxis: [
            {
              data: xAxisData
            }
          ],
          series: {
            data: chartsData[0]
          }
        })
        this.gasConsumption.setOption({
          xAxis: [
            {
              data: xAxisData
            }
          ],
          series: {
            data: chartsData[1]
          }
        })
        this.electricityConsumption.setOption({
          xAxis: [
            {
              data: xAxisData
            }
          ],
          series: {
            data: chartsData[2]
          }
        })
      }, 60000)

      this.tenSeconds = setInterval(this.getRunningState, 10000)

      this.timerOfEffectiveState = setInterval(this.changeEffectiveState, 10000)
    },
    clearTimers() {
      if(this.oneMinute) {
        clearInterval(this.oneMinute)
        this.oneMinute = null
      }
      if(this.tenSeconds) {
        clearInterval(this.tenSeconds)
        this.tenSeconds = null
      }
      if(this.timerOfEffectiveState) {
        clearInterval(this.timerOfEffectiveState)
        this.timerOfEffectiveState = null
      }
    },
    connectServer() {
      if(this.webSocket) {
        this.webSocket.close()
      }

      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.webSocket = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/group/${this.stationId}?token=${authorization}`)

      this.webSocket.onopen = () => {
        this.webSocket.send(this.deviceCodes + '')
        this.limitConnect++
      }

      this.webSocket.onmessage = e => {
        if(e.data === this.stationCode) {
          this.fWebSocket = true
          return
        }
        const record = JSON.parse(e.data)
        if(!record.device_code) {
          this.liveKw = record?.power || this.liveKw
          this.liveNm = record?.flow || this.liveNm
          this.liveP = record?.gasElectricRatio || this.liveP
        } else if(record.device_code === this.deviceCode) {
          if(this.pressure.length > 100) {
            this.pressure.shift()
            this.lineXAxis.shift()
          }
          if(record[this.setData]) {
            if (this.pressure.length === 0) {
              const time = moment(+new Date()).format("HH:mm:ss")
              this.pressure.push(record[this.setData])
              this.lineXAxis.push(time)
              this.pressure.push(record[this.setData])
              this.lineXAxis.push(time)
            } else if (this.pressure.length === 2 && this.lineXAxis[0] === this.lineXAxis[1]) {
              this.lineXAxis[1] = moment(+new Date()).format("HH:mm:ss")
              this.pressure[1] = record[this.setData]
            } else {
              this.pressure.push(record[this.setData])
              this.lineXAxis.push(moment(+new Date()).format("HH:mm:ss"))
            }

            this.pressureChart?.setOption({
              xAxis: {
                data: this.lineXAxis
              },
              series: [
                {
                  data: this.pressure
                }
              ]
            })
          }
        }

        const block = this.stage.find(".deviceData")
        block.forEach(item => {
          if(item.attrs.device.deviceCode === record.device_code) {
            if(!item.attrs.device_id) {
              return
            }
          }
          const contentNode = item
          const list = item.attrs.dataPointList.filter(a => a.show)
          contentNode.text("")
          let str = contentNode.text()
          list.forEach((a, i) => {
            if(record[a.code] !== "--") {
              sessionStorage.setItem(a.name, record[a.code])
            }

            if(index < list.length - 1) {
              str += `${a.name}:\t${record[a.code] === "--" ? sessionStorage.getItem(a.name) : record[a.code]} ${a.unit}\n`
            } else {
              str += `${a.name}:\t${record[a.code] === "--" ? sessionStorage.getItem(a.name) : record[a.code]} ${a.unit}`
            }
          })
          contentNode.text(str)
        })

        const blockList = this.stage.find(".dataRow")
        blockList.forEach(item => {
          const device = item.getAttr("device")
          const point = item.getAttr("dataPoint")
          if(!device || !point) {
            return
          }
          if(device.code === record.device_code && item.findOne(".dataValue")) {
            const value = item.findOne(".dataValue")
            value.text(record[point.code])
          }
        })

        const list = this.stage.find(".dataBlock")
        const deviceCode = record.device_code
        list.forEach(block => {
          const device = block.getAttr("device")
          if(record.deviceStatus && device && device.code === deviceCode) {
            let tags = record.deviceStatus.split(",")
            tags = tags.map(t => {
              const c = this.deviceStatus.find(d => d.value === t)
              return c
            })
            widget.dataBlock.updateHeaderTag(block, tags)
          }
        })

        const monitors = this.stage.find('.monitorBlock')
        monitors.forEach(m => {
          const device = m.getAttr('device')
          if (device && device.code === record.device_code) {
            const rows = m.find('.monitorRow')
            rows.forEach(r => {
              const point = r.getAttr('dataPoint')
              if (point) {
                r.findOne('.monitorValue').text(record[point.code])
              }
            })
            if (record.deviceStatus) {
              let tags = record.deviceStatus.split(",")
              tags = tags.map(t => {
                const c = this.deviceStatus.find(d => d.value === t)
                return c
              })
              widget.dataBlock.updateHeaderTag(m, tags)
            }
          }
        })

        const stackedLine = this.stage.find('.StackedLine')
        if (stackedLine?.length) {
          stackedLine.forEach(s => {
            const code = s.getAttr('deviceCode')
            const id = s.getAttr('id')
            const point = s.getAttr('point')
            const maxPoints = s.getAttr('maxPoints')
            if (code && point && record.device_code === code) {
              if (maxPoints && this.options?.[id]?.xAxis.data?.length == maxPoints) {
                this.options[id].xAxis.data.shift()
                this.options[id].series[0].data.shift()
              }
              if (this.options[id]) {
                this.options[id].xAxis.data.push(moment(+new Date()).format("HH:mm:ss"))
                const index = this.options[id].series[0].data.length - 1
                const lastPoint = this.options[id].series[0].data[index]

                if (lastPoint.label) {
                  delete lastPoint.label
                  lastPoint.symbol = 'none'
                }
                this.options[id].series[0].data.push({
                  value: record[point],
                  label: {
                    show: true,
                    position: 'top'
                  }
                })
                this.charts[id]?.setOption(this.options[id], { replaceMerge: ['yAxis', 'grid', 'series'] })
              }
            }
          })
        }

        const stackedLine2 = this.stage.find('.stackedLine2')
        if (stackedLine2?.length) {
          stackedLine2.forEach(s => {
            const code = s.getAttr('deviceCode')
            const id = s.getAttr('id')
            const point = s.getAttr('point')
            const maxPoints = s.getAttr('maxPoints')
            if (code && point && record.device_code === code) {
              if (maxPoints && this.options?.[id]?.xAxis.data?.length == maxPoints) {
                this.options[id].xAxis.data.shift()
                this.options[id].series[0].data.shift()
              }
              if (this.options[id]) {
                this.options[id].xAxis.data.push(moment(+new Date()).format("HH:mm:ss"))
                const index = this.options[id].series[0].data.length - 1
                const lastPoint = this.options[id].series[0].data[index]

                if (lastPoint.label) {
                  delete lastPoint.label
                }
                this.options[id].series[0].data.push({
                  value: record[point],
                  label: {
                    show: true,
                    position: 'top'
                  }
                })
                this.charts[id]?.setOption(this.options[id], { replaceMerge: ['yAxis', 'grid', 'series'] })
              }
            }
          })
        }
      }

      this.webSocket.onerror = (e) => {
        console.log(e);
        // this.reconnect()
      }
      this.webSocket.onclose = (e) => {
        console.log(e);
        // this.reconnect()
      }

      // if(!this.hbpSenderTimer) {
      //   this.hbpSenderTimer = setInterval(() => {
      //     if(this.webSocket) {
      //       try {
      //         this.webSocket.send(this.stationCode)
      //         this.fWebSocket = false
      //       } catch (e) {
      //         this.fWebSocket = false
      //       } finally {
      //         this.fWebSocket = false
      //         setTimeout(() => {
      //           if(!this.fWebSocket) {
      //             if (this.webSocket) {
      //               this.webSocket.close()
      //               this.webSocket = null
      //             }
      //             if (this.limitConnect === 1) {
      //               this.limitConnect--
      //             }
      //             this.reconnect()
      //           }
      //         }, 3000)
      //       }
      //     } else {
      //       this.reconnect()
      //     }
      //   }, 10000)
      // }
    },
    reconnect() {
      if(!this.connecting) {
        this.connecting = true
        setTimeout(() => {
          this.connectServer()
          this.connecting = false
        }, 10000)
      }
    },
    async getRunningState() {
      try {
        const { data } = await getDevicesStatus(this.$route.query.id)
        this.runningState = data
      } catch(e) {
        console.log(e);
      }
    },
    async setConfigurationDeviceStatus(node) {
      try {
        const { data } = await getDevicesStatus(this.$route.query.id)
        for (let key in data) {
          node.findOne(`.${key}Value`).text(data[key] + '台')
        }
      } catch(e) {
        console.log(e)
      }
    },
    async setStatsWidgetData(interval = 60) {
      const statsWidgets = {}, aggregations = []
      this.stage.find('.statsValue').forEach(n => {
        const value = n.getAttr('data')
        const {
          deviceId,
          pointCode,
          aggregationType
        } = value
        if (deviceId > 0 && pointCode !== '' && aggregationType !== '') {
          statsWidgets[value.deviceId] = n
          aggregations.push(value)
        }
      })
      let result = {}
      const { data } = await getDeviceAggregation(aggregations)
      data.forEach(d => {
        result[d.deviceId] = d.value
      })
      for (let k in statsWidgets) {
        if (result[k]) {
          statsWidgets[k].text(result[k])
        } else {
          statsWidgets[k].text(0)
        }
      }
      this.statsInterval = setInterval(async () => {
        result = {}
        const { data } = await getDeviceAggregation(aggregations)
        data.forEach(d => {
          result[d.deviceId] = d.value
        })
        for (let k in statsWidgets) {
          if (result[k]) {
            statsWidgets[k].text(result[k])
          } else {
            statsWidgets[k].text(0)
          }
        }
      }, interval * 1000)
    },
    drawChartsGroup(xAxisData = [], chartsData = []) {
      const chartsGroup = document.querySelectorAll(".charts .unit ~ div")
      const option = {
        tooltip: {
          trigger: "axis"
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            axisLabel: {
              show: true,
              color: "#fff",
              fontSize: (this.chartFontSize ? (this.chartFontSize - 5) : "12") * (this.mobileScale || 1)
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            data: xAxisData
          }
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: {
          stack: "Total",
          showSymbol: true,
          symbolSize: 0
        },
        grid: {
          top: "25%",
          left: "5%",
          right: "6%",
          bottom: "20%"
        }
      }
      chartsGroup.forEach(el => {
        this[el.id] = this.$echarts.init(
          document.getElementById(el.id),
          null,
          {
            renderer: "canvas",
            useDirtyRect: false
          }
        )
      })

      option.series.name = "气电比"
      option.series.type = "line"
      option.series.lineStyle = { color: "#80FFA5", width: 2 }
      option.series.smooth = false
      option.series.areaStyle = {
        opacity: 0.6,
        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(128,255,165, .6)"
          },
          {
            offset: 1,
            color: "rgba(1, 191, 236, .2)"
          }
        ])
      }
      option.series.data = chartsData[0]
      this.percent.setOption(option)

      option.series.name = "用气量"
      option.series.type = "bar"
      option.series.itemStyle = {
        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "#00DDFF"
          },
          {
            offset: 1,
            color: "rgb(0,21,41)"
          }
        ])
      }
      option.series.data = chartsData[1]
      option.barWidth = "50%"
      this.gasConsumption.setOption(option)

      option.series.name = "用电量"
      option.series.itemStyle = {
        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "#37A2FF"
          },
          {
            offset: 1,
            color: "rgb(0,21,41)"
          }
        ])
      }
      option.series.data = chartsData[2]
      this.electricityConsumption.setOption(option)
    },
    stopAnimation() {
      if(this.timerOfEffectiveState) {
        clearInterval(this.timerOfEffectiveState)
        this.timerOfEffectiveState = null
      }
    },
    runAnimation() {
      this.stopAnimation()
      this.timerOfEffectiveState = setInterval(this.changeEffectiveState, 10000)
    },
    async noticeWarning() {
      this.confirmLoading = true
      try {
        const { message } = await noticeWarningRecord(this.record.id)
        this.$message.success(message)
        this.getWarningData()
      } catch (err) {
        console.error(err)
      } finally {
        this.confirmLoading = false
        this.visible = false
        this.playAnimation()
      }
    },
    handleCancel () {
      this.visible = false
      this.playAnimation()
    },
    async getEffectiveAccumulationData(effectiveAccumulation) {
      const e = effectiveAccumulation.getAttr('e') || []
      const f = effectiveAccumulation.getAttr('f') || []
      const deviceCodes = e.concat(f)

      if (deviceCodes.length) {
        let endDate = +new Date()
        let startDate = endDate - 30 * 24 * 3600 * 1000
        endDate = moment(endDate).format('YYYY-MM-DD')
        startDate = moment(startDate).format('YYYY-MM-DD')
        const { data } = await getMonthReport(startDate, endDate, deviceCodes + '')
        let target, totalNm = 0, totalKwh = 0, totalP
        for (let i = data.length - 2; i > -1; i--) {
          target = data[i]
          if (target.electricityMeterAccumulation > 0) {
            totalKwh = target.electricityMeterAccumulation - this.eReduce
            totalKwh = totalKwh > 0 ? totalKwh : 0
            if (target.flowMeterAccumulation > 0) {
              totalNm = target.flowMeterAccumulation - this.gReduce
              totalNm = totalNm > 0 ? totalNm : 0
            }
            break
          }
        }
        totalP = totalNm == 0 ? 0 : (totalKwh / totalNm)
        totalP = totalP.toFixed(5)
        totalKwh = totalKwh.toFixed(0)
        totalNm = totalNm.toFixed(0)
        effectiveAccumulation.findOne('.ev')?.text(totalKwh)
        effectiveAccumulation.findOne('.fv')?.text(totalNm)
        effectiveAccumulation.findOne('.ratioValue')?.text(totalP)
      } else {
        effectiveAccumulation.findOne('.ev').text('0')
        effectiveAccumulation.findOne('.fv').text('0')
        effectiveAccumulation.findOne('.ratioValue').text('0.00000')
      }
    },
    async setSocialEffectiveState(n) {
      const e = n.getAttr('e') || []
      const f = n.getAttr('f') || []
      const deviceCodes = e.concat(f)
      if (deviceCodes.length) {
        const endDate = +new Date()
        const startDate = endDate - 30 * 24 * 3600 * 1000
        try {
          const { data } = await getMonthReport(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), deviceCodes + '')
          let target, totalNm = 0, totalKwh = 0
          for (let i = data.length - 2; i > -1; i--) {
            target = data[i]
            if (target.electricityMeterAccumulation > 0) {
              totalKwh = target.electricityMeterAccumulation - this.eReduce
              totalKwh = totalKwh > 0 ? totalKwh : 0
              if (target.flowMeterAccumulation > 0) {
                totalNm = target.flowMeterAccumulation - this.gReduce
                totalNm = totalNm > 0 ? totalNm : 0
              }
              break
            }
          }
          const totalReduce = (this.gasElectricRatio * totalNm - totalKwh).toFixed(0)
          const CO2 = (totalReduce * 0.942 / 1000).toFixed(3)

          const powerValue = n.findOne('.powerValue')
          if (powerValue) {
            powerValue.setText(totalReduce)
          }
          const CO2Value = n.findOne('.CO2Value')
          if (CO2Value) {
            CO2Value.setText(CO2)
          }
        } catch(e) {
          console.log(e)
        }
      } else {
        const powerValue = this.currentItem.findOne('.powerValue')
        if (powerValue) {
          powerValue.setText(totalReduce)
        }
        const CO2Value = this.currentItem.findOne('.CO2Value')
        if (CO2Value) {
          CO2Value.setText(CO2)
        }
      }
    },
    getMonday(d) {
      const date = new Date(d)

      const dayOfWeek = date.getDay()
      const mondayOffset = dayOfWeek === 0 ? 6 : dayOfWeek - 1

      const monday = new Date(date)
      monday.setDate(date.getDate() - mondayOffset)
      monday.setHours(0, 0, 0, 0)

      return monday
    },
    getSunday(d) {
      const date = new Date(d)

      const dayOfWeek = date.getDay()
      const sundayOffset = dayOfWeek === 0 ? 0 : 7 - dayOfWeek

      const sunday = new Date(date)
      sunday.setDate(date.getDate() + sundayOffset)
      sunday.setHours(23, 59, 59, 999)

      return sunday
    },
    getWeekNumber(d) {
      const date = new Date(d)
      date.setHours(0, 0, 0, 0)

      const dayOfWeek = date.getDay()
      const thursdayOffset = dayOfWeek <= 4 ? 4 - dayOfWeek : 11 - dayOfWeek
      const thursday = new Date(date)
      thursday.setDate(date.getDate() + thursdayOffset)

      const year = thursday.getFullYear()
      const firstDayOfYear = new Date(year, 0, 1)
      const firsThursday = new Date(firstDayOfYear)

      const firstDayOfWeek = firstDayOfYear.getDay()
      const daysToFirstThursday = firstDayOfWeek <= 4 ? 4 - firstDayOfWeek : 11- firstDayOfWeek
      firsThursday.setDate(firstDayOfYear.getDate() + daysToFirstThursday)

      if (firsThursday.getTime() > thursday.getTime()) {
        const prevYear = year - 1
        const prevFirstDayOfYear = new Date(prevYear, 0, 1)
        const prevFirstThursday = new Date(prevFirstDayOfYear)

        const prevFirstDayOfWeek = prevFirstDayOfYear.getDay()
        const prevDaysToFirstThursday = prevFirstDayOfWeek <= 4 ? 4 - prevFirstDayOfWeek : 11 - prevFirstDayOfWeek
        prevFirstThursday.setDate(prevFirstDayOfYear.getDate() + prevDaysToFirstThursday)

        const diffInMs = thursday - prevFirstThursday
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
        const weekNumber = Math.floor(diffInDays / 7) + 1

        return {
          weekNumber,
          year: prevYear
        }
      }

      const diffInMs = thursday - firsThursday
      const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
      const weekNumber = Math.floor(diffInDays / 7) + 1;

      return {
        weekNumber,
        year
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.preview1 {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  &.showX {
    overflow-x: auto;
  }
}
li {
  list-style: none;
}
.container {
  height: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
#container {
  position: relative;
  background-color: #000334;
  .models {
    position: absolute;
    background-color: #000334;
    left: 0;
    right: 0;
    top: 0;
    transform: translateY(-100%);
  }

  .scrollBar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: 100;
  }
  #preview {
    width: 100%;
    height: auto;
  }
  .left,
  .right {
    width: 20.8%;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 11%;
    bottom: 5%;
    .box {
      width: 100%;
      height: 15%;
      background: url("../../../../assets/backBorder.png");
      // border: 5px solid;
      // border-image: linear-gradient(to right, #8f41e9, #578aef) 1;
      background-size: 100% 100%;
      position: relative;
      .container {
        overflow: unset;
      }
      .title {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -55%);
        color: #fff;
        font-size: .21rem;
      }
    }
  }
  .left{
    left: 2.4%;
    .box {
      &#effectiveState {
        flex: 2.5;
        overflow-x: clip;
        .left,
        .right {
          position: absolute;
          width: 20px;
          height: 40px;
          top: 50%;
          transform: translateY(-50%);
          background: url("../../../../assets/left.png");
          z-index: 10;
          cursor: pointer;
        }
        .left {
          left: 2%;
        }
        .right {
          right: 2%;
          background: url("../../../../assets/right.png");
        }
        ul {
          position: absolute;
          width: 200%;
          height: 100%;
          left: 0;
          // background-color: skyblue;
          li {
            width: 50%;
            height: 100%;
            // background-color: pink;
            float: left;
            padding: 1.8% 30px;
            h3 {
              font-size: .225rem;
              color: rgb(164, 216, 255);
            }
            .wrapper {
              display: flex;
              justify-content: space-around;
              margin: 4.5%;
              .innerTitle {
                font-size: .2rem;
                color: rgb(164, 216, 255);
                white-space: nowrap;
              }
              span {
                font-size: .2rem;
                color: #fff;
              }
            }
            .gasElectricRatio {
              width: 100%;
              height: .4167rem;
              line-height: .4167rem;
              border: 1px solid rgb(164, 216, 255);
              border-radius: 20px;
              box-shadow: -1px -1px 6px 2px rgba(164, 216, 255, 1) inset;
              color: rgb(164, 216, 255);
              text-align: center;
              font-size: .2rem;
            }
          }
        }
      }
      &#socialBenefit {
        flex: 1.25;
        margin: 6% 0 15%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .title {
          top: 0;
        }
        .innerTitle {
          font-size: .2rem;
          color: rgb(164, 216, 255);
        }
        span {
          font-size: .2rem;
          color: #fff;
        }
      }
      &.charts {
        flex: 6.25;
        background-image: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .chartsTitle {
          color: #fff;
          font-size: .21rem;
          position: absolute;
          left: 50%;
          top: -11%;
          transform: translateX(-50%);
          white-space: nowrap;
        }
        .container {
          width: 100%;
          height: 30%;
          background: url("../../../../assets/backBorder.png");
          background-size: 100% 100%;
          position: relative;
          .title {
            font-size: .2rem;
          }
          .unit {
            position: absolute;
            color: #a4d8ff;
            left: 50%;
            top: 8%;
            transform: translateX(-50%);
            font-size: .18rem;
          }
          div {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .right {
    right: 2.4%;
    .box {
      &#runningState{
        flex: 3;
        .wrapper {
          width: 100%;
          height: 50%;
          display: flex;
          justify-content: space-around;
          li {
            width: 30%;
            height: 75%;
            // background-color: skyblue;
            display: flex;
            flex-direction: column;
            align-items: center;
            .text {
              font-size: .2rem;
            }
            .description {
              font-size: .175rem;
            }
            .img {
              width: 100%;
              height: 70%;
            }
            &.online {
               .img {
                  background: url("../../../../assets/1.png") center no-repeat;
               }
               .text {
                color: #117b8a;
               }
               .description {
                color: #117b8a;
               }
            }
            &.standy {
               .img {
                  background: url("../../../../assets/2.png") center no-repeat;
               }
               .text {
                color: #2d65ae;
               }
               .description {
                color: #2d65ae;
               }
            }
            &.offline {
               .img {
                  background: url("../../../../assets/3.png") center no-repeat;
               }
               .text {
                color: #b8b8bb;
               }
               .description {
                color: #b8b8bb;
               }
            }
            &.hitch {
              .img {
                background: url("../../../../assets/4.png") center no-repeat;
              }
              .text {
                color: #ca0400;
              }
              .description {
                color: #ca0400;
              }
            }
            &.maintain {
              .img {
                background: url("../../../../assets/5.png") center no-repeat;
              }
              .text {
                color: #eeab03;
              }
              .description {
                color: #eeab03;
              }
            }
          }
          &:nth-child(3) {
            position: absolute;
            width: 71.25%;
            top: 58%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &#live {
        flex: 3;
        margin: 15px 0;
        #pressure {
          width: 100%;
          height: 100%;
        }
        span {
          color: rgba(164, 216, 255, 1);
          font-size: .225rem;
          position: absolute;
          left: 50%;
          top: 3%;
          transform: translateX(-50%);
          &[class^="symbol"] {
            transform: translate(-15%, 80%);
            color: #fff;
          }
          &.symbol_right {
            left: 87%;
          }
        }
      }
      &#warningRecord {
        flex: 4;
        .marquee {
          width: 93%;
          position: absolute;
          top: 9%;
          left: 3%;
          bottom: 5%;
          overflow: hidden;
          .marquee-view {
            animation-name: scroll;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            /* animation-delay: 6s; */
            animation-delay: 1s;
            // animation-duration: 10s;
            // animation-play-state: running;
            // overflow: hidden;
            // transform: translateY(-50%);
            li {
              width: 100%;
              height: 70px;
              cursor: pointer;
              .container {
                position: relative;
                width: 100%;
                height: 100%;
                .date {
                  color: #fff;
                }
                .scroll {
                  position: absolute;
                  top: 0;
                  left: 0;
                  white-space: nowrap;
                  .col {
                    display: inline-block;
                    padding-left: 8px;
                    font-size: .15rem;
                    line-height: 1.5;
                    color: #a4d8ff;
                  }
                }
                .flex {
                  position: absolute;
                  padding-left: 8px;
                  left: 0;
                  top: 0;
                  right: 0;
                  span:first-child {
                    font-size: .15rem;
                  }
                  .content {
                    position: absolute;
                    right: 0;
                  }
                }
              }
              .animation {
                animation: rowScroll 6s linear infinite;
                animation-play-state: paused;
                &:hover {
                  animation-play-state: running;
                }
              }
              .row:not(.scroll) {
                padding-top: 30px;
                display: flex;
                justify-content: space-between;
                color: #a4d8ff;
              }
              &.PROMPT {
                .color {
                  color: #52c41a;
                }
              }
              &.IMPORTANT {
                .color {
                  color: #ff9000;
                }
              }
              &.MINOR {
                .color {
                  color: #fed557;
                }
              }
              &.URGENT {
                .color {
                  color: #ff8989;
                }
              }
            }
          }
        }
      }
    }
  }
}
@keyframes scroll {
  0% {}
  100% {
    transform: translateY(-50%);
  }
}
@keyframes rowScroll {
  0% {}
  100% {
    transform: translateX(-50%);
  }
}
@media screen and (max-width: 1680px) {
  #effectiveState .wrapper {
    margin: 3.6% !important;
  }
}
@media screen and (max-width: 1440px) {
  .w {
    overflow-x: auto;
  }
  #container .right .box#warningRecord .marquee .marquee-view li .container .flex .content {
    right: unset;
    white-space: nowrap;
  }
}
@media screen and (max-width: 820px) {
  .innerTitle {
    font-size: .15rem;
  }
  :-webkit-full-screen #effectiveState,
  :-webkit-full-screen #socialBenefit,
  :-webkit-full-screen .charts,
  :-webkit-full-screen #runningState,
  :-webkit-full-screen #live,
  :-webkit-full-screen #warningRecord {
    .innerTitle {
      font-size: .15rem !important;
      scale: .8 !important;
    }
    width: 103% !important;
    transform: scaleY(.8);
    h3 {
      display: none;
    }
    .gasElectricRatio {
      overflow: hidden;
      transform: scaleY(.6) translateY(-30%);
    }
  }
  :-webkit-full-screen .charts {
    flex: 10 !important;
  }
  :-webkit-full-screen #runningState {
    flex: 6 !important;
  }
  :-webkit-full-screen #effectiveState {
    flex: 3 !important;
    text-align: center !important;
    height: 20px !important;
  }
  :-webkit-full-screen #live {
    flex: 5 !important;
    margin: 0 !important;
  }
  :-webkit-full-screen #socialBenefit {
    margin: 2% 0 !important;
    flex: 2 !important;
  }
}
</style>
